module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "clearfix nooverflow"
  }, [_c('div', {
    staticClass: "alert",
    class: [_vm.className, _vm.css]
  }, [_c('button', {
    staticClass: "close rp-alert-icon-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-times"
  })]), _vm._v("\n\t\t\t" + _vm._s(_vm.message) + "\n\t\t\t"), (_vm.buttons.length) ? _c('div', {
    staticClass: "clearfix text-center"
  }, _vm._l((_vm.buttons), function(button) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: button.class,
      on: {
        "click": button.action
      }
    }, [_vm._v(_vm._s(button.label))])
  })) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ccacf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Alert.vue
// module id = 470
// module chunks = 0